import { render, staticRenderFns } from "./BlogPostsFilter.vue?vue&type=template&id=a84ce408&"
import script from "./BlogPostsFilter.vue?vue&type=script&lang=js&"
export * from "./BlogPostsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports